import React from "react";
import { Container, Row, Col, Card, CardBody, DatePicker } from "shards-react";
import PageTitle from "../components/common/PageTitle";
import { Redirect, Link } from "react-router-dom";
import { appName } from "../global";
import { Helmet } from "react-helmet";
import ScrollToTop from "../components/layout/ScrollToTop";
import { withToastManager } from "react-toast-notifications";
import { connect } from "react-redux";
import Loading from "react-loading-bar";
import Error500 from "./Error500";
import Table from "../components/table/Table";
import Error403 from "./Error403";
import { fetchReceiving } from "../store/actions/receivingActions";
import moment from "moment";

class Receiving extends React.Component {
  state = {
    search: null,
    page: 1,
    perpage: 10,
    keyword: null,
    alert: true,
    alertMsgBox: false,
    deleteIdPlant: null,
    showMsgBox: false,
    isDeleted: false,
    ordering: {
      type: "plant",
      sort: "asc",
    },
    modal: false,
    file_import: null,
    import: "Choose file...",
    importing: false,
    checked: [],
    start_date: null,
    end_date: null,
  };

  handleSorting = (e) => {
    const type = e.target.id;
    const sort = this.state.ordering.sort;
    this.setState({
      ...this.state,
      ordering: {
        type: type,
        sort: sort === "asc" ? "desc" : "asc",
      },
    });
  };

  handleChangeKeyword = (e) => {
    this.setState({
      ...this.state,
      [e.target.id]: e.target.value,
    });
  };

  handleSubmitKeyword = (e) => {
    e.preventDefault();
    this.props.fetchReceiving(this.state);
  };

  handleClearKeyword = (e) => {
    this.setState({
      ...this.state,
      start_date: null,
      end_date: null,
    });
    this.props.fetchReceiving({
      ...this.state,
      start_date: null,
      end_date: null,
    });
  };

  handleClickPage = (e) => {
    this.setState({
      ...this.state,
      page: e,
    });
  };

  hanldeChangePage = (e) => {
    this.setState({
      ...this.state,
      perpage: e.target.value,
    });
  };

  handleClickDelete = (id) => {
    this.setState({
      ...this.state,
      deleteIdPlant: id,
      showMsgBox: true,
    });
  };

  handleClickYes = () => {
    this.setState({
      ...this.state,
      alertMsgBox: true,
      showMsgBox: false,
      isDeleted: true,
    });

    this.props.deletePlant(this.state.deleteIdPlant);
  };

  handleClickNo = () => {
    this.setState({
      ...this.state,
      showMsgBox: false,
      deleteIdPlant: null,
    });
  };

  componentWillUpdate(nextProps, nextState) {
    if (this.state.page !== nextState.page) {
      this.props.fetchReceiving(nextState);
    }

    if (this.state.perpage !== nextState.perpage) {
      this.props.fetchReceiving(nextState);
    }

    if (this.state.ordering !== nextState.ordering) {
      this.props.fetchReceiving(nextState);
    }
  }

  componentDidUpdate = (prevProps, prevState) => {
    if (prevProps.error !== this.props.error) {
      if (!this.props.fetched) {
        if (this.props.error) {
          const { toastManager } = this.props;
          toastManager.add(this.props.error.data.message, {
            appearance: "error",
            autoDismiss: true,
          });
        }
      }
    }

    if (prevProps.isDeleted !== this.props.isDeleted) {
      if (this.props.isDeleted) {
        const { toastManager } = this.props;
        toastManager.add(this.props.message, {
          appearance: "success",
          autoDismiss: true,
        });
        this.props.fetchReceiving(this.state);
      }
    }
  };

  handleModal = () => {
    this.setState({
      ...this.state,
      modal: true,
    });
  };

  modalBackdropClicked = () => {
    this.setState({
      ...this.state,
      modal: false,
    });
  };

  handleChangeDate = (name, value) => {
    this.setState({
      ...this.state,
      [name]: value,
    });
  };

  componentDidMount = () => {
    this.props.fetchReceiving(this.state);
  };

  render() {
    const { receiving, error, fetching } = this.props;
    const { start_date, end_date } = this.state;

    if (!localStorage.getItem("token")) return <Redirect to="/login" />;
    if (error && error.status === 500)
      return <Error500 message={error.data.message} />;
    if (error && error.status === 403)
      return <Error403 message={error.data.message} />;

    const { ordering } = this.state;
    const theads = [
      { name: "lot_id_coil", value: "Lot ID", sortable: true },
      { name: "spec", value: "Specification", sortable: true },
      { name: "size", value: "Size", sortable: true },
      { name: "customer_name", value: "Customer", sortable: true },
      { name: "part_no", value: "Part Number", sortable: true },
      { name: "part_name", value: "Part Name", sortable: true },
      { name: "qty", value: "Qty", sortable: true },
      { name: "weight", value: "Weight", sortable: true },
      { name: "receive_date", value: "Scanned Date", sortable: true },
    ];
    console.log(receiving)
    const receivings =
      receiving &&
      receiving.data.map((receive, index) => {
        return (
          <tr key={receive._id}>
            <td>{receive.lot_id_coil}</td>
            <td>{receive.spec}</td>
            <td>{`${receive.size_1}x${receive.size_2}x${receive.size_3}`}</td>
            <td>{receive.customer_name}</td>
            <td>{receive.part_no}</td>
            <td>{receive.part_name}</td>
            <td>{receive.qty}/box</td>
            <td>{receive.weight}/Kg(s)</td>
            <td>{moment(receive.receive_date).format("DD/MM/YYYY")}</td>
          </tr>
        );
      });

    return (
      <Container fluid className="main-content-container px-4">
        <Loading show={fetching} color="blue" showSpinner={false} />
        <Helmet>
          <title>Receiving | {appName} </title>
        </Helmet>
        <Row noGutters className="page-header py-4">
          <PageTitle sm="4" title="Receiving" className="text-sm-left" />
        </Row>

        <Row>
          <Col>
            <Card small className="mb-4">
              <CardBody className="p-0 pb-3">
                <div className="col-md-12 mt-4">
                  <div className="row">
                    <div className="col-md-8">
                      <Link to="/receiving/scan" className="btn btn-secondary">
                        <i className="mdi mdi-plus"></i> Scan Receiving
                      </Link>
                    </div>
                    <div className="col-md-4 text-right">
                      <form onSubmit={this.handleSubmitKeyword}>
                        <div className="input-group mb-3">
                          <input
                            id="keyword"
                            type="text"
                            className="form-control"
                            placeholder=""
                            aria-label="Example text with button addon"
                            aria-describedby="button-addon1"
                            onChange={this.handleChangeKeyword}
                          />
                          <div className="input-group-prepend">
                            <button
                              className="btn btn-secondary"
                              type="submit"
                              id="button-addon1"
                            >
                              <i className="mdi mdi-magnify" /> Search{" "}
                            </button>
                          </div>
                        </div>
                      </form>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-md-12">
                      <div className="form-gruop">
                        <label className="mb-2">Filter by Date</label>
                        <div className="row">
                          <div className="col-md-2 mr-2">
                            <DatePicker
                              placeholderText="From"
                              selected={start_date}
                              onChange={(e) =>
                                this.handleChangeDate("start_date", e)
                              }
                            />
                          </div>
                          <div className="col-md-2">
                            <DatePicker
                              placeholderText="To"
                              selected={end_date}
                              onChange={(e) =>
                                this.handleChangeDate("end_date", e)
                              }
                            />
                          </div>
                          <div className="col-md-4">
                            <button
                              className="btn btn-primary mr-2"
                              onClick={this.handleSubmitKeyword}
                            >
                              <i className="mdi mdi-filter" /> Filter
                            </button>
                            {(start_date || end_date) && (
                              <button
                                className="btn btn-secondary"
                                onClick={this.handleClearKeyword}
                              >
                                <i className="mdi mdi-close" /> Clear Filter
                              </button>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-md-12 mt-3">
                  <Table
                    theads={theads}
                    ordering={ordering}
                    handleSorting={this.handleSorting}
                  >
                    {fetching ? (
                      <tr>
                        <td className="text-center" colSpan="8">
                          Loading...
                        </td>
                      </tr>
                    ) : receiving && receiving.data.length > 0 ? (
                      receiving && receivings
                    ) : (
                      <tr>
                        <td className="text-center" colSpan="8">
                          Data not found
                        </td>
                      </tr>
                    )}
                  </Table>
                </div>

                <div className="col-md-12 py-3">
                  <div className="row">
                    <div className="col-md-10">
                      {receiving && receiving.total > 1 && (
                        <p>
                          Showing {receiving && receiving.from.toLocaleString()}{" "}
                          to {receiving && receiving.to.toLocaleString()} of{" "}
                          {receiving && receiving.total.toLocaleString()}{" "}
                          record(s)
                        </p>
                      )}

                      {receiving && receiving.total > 1 && (
                        <nav aria-label="Page navigation example">
                          <ul className="pagination">
                            {receiving && receiving.current_page > 1 && (
                              <li key="prev" className="page-item">
                                <button
                                  onClick={this.handleClickPage.bind(
                                    null,
                                    receiving && receiving.current_page - 1
                                  )}
                                  className="page-link"
                                >
                                  Prev
                                </button>
                              </li>
                            )}

                            {receiving &&
                              receiving.pages.map((page, index) => {
                                return (
                                  <li
                                    key={index}
                                    className={`page-item ${
                                      page === "..." ? "disabled" : ""
                                    } ${
                                      page === receiving &&
                                      receiving.current_page
                                        ? "active"
                                        : ""
                                    }`}
                                  >
                                    <button
                                      onClick={this.handleClickPage.bind(
                                        null,
                                        page
                                      )}
                                      className="page-link"
                                    >
                                      {page}
                                    </button>
                                  </li>
                                );
                              })}

                            {receiving &&
                              receiving.current_page < receiving &&
                              receiving.last_page && (
                                <li key="next" className="page-item">
                                  <button
                                    onClick={this.handleClickPage.bind(
                                      null,
                                      receiving && receiving.current_page + 1
                                    )}
                                    className="page-link"
                                  >
                                    Next
                                  </button>
                                </li>
                              )}
                          </ul>
                        </nav>
                      )}
                    </div>
                    <div className="col-md-2 text-right">
                      <div className="form-group">
                        <label className="control-label">
                          Showing per page{" "}
                        </label>
                        <select
                          defaultValue="10"
                          id="perpage"
                          className="form-control custom-select"
                          onChange={this.hanldeChangePage}
                        >
                          <option value="5">5</option>
                          <option value="10">10</option>
                          <option value="50">50</option>
                          <option value="100">100</option>
                        </select>
                      </div>
                    </div>
                  </div>
                </div>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    ...state,
    receiving: state.receiving.receiving,
    error: state.receiving.error,
    fetching: state.loading.fetching,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    fetchReceiving: (filter) => dispatch(fetchReceiving(filter)),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withToastManager(Receiving));
